module.exports = __webpack_public_path__ + "static/media/The Magic Touch By Daniele.37dbbac4.png";